import * as React from 'react';

import { EngineRenderers } from '@websky/core/src/renderProps';
import { CloseClear } from '@websky/core';

const PassengersCloseBtn: EngineRenderers['SearchFormPassengersCloseBtn'] = ({ close }) => (
	<span onClick={close}>{CloseClear}</span>
);

export default PassengersCloseBtn;
